const enrollFilterType = {
  ENGAGED_IN: 'engaged_in',
  COMMENTED_IN: 'commented_in',
  IN_SEGMENT: 'in_segment',
  YOU_MESSAGED_THEM: 'you_messaged_them',
  THEY_MESSAGED_YOU: 'they_messaged_you',
  HAS_FOLLOWER_COUNT: 'has_follower_count',
  CAN_SEND_DM_QUERY: 'CAN_SEND_DM_QUERY',
  TWITTER_LIST: 'TWITTER_LIST',
};

export default enrollFilterType;
